export default {
  wrapper: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  toggleWrapper: {
    cursor: 'pointer',
    opacity: '.7',
  },
  itemsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    backgroundColor: 'white',
    borderRadius: '10px',
    position: 'absolute',
    top: '-15px',
    transform: 'translate(0, -100%)',
    visibility: 'hidden',
    boxShadow: '1px 1px 5px hsla(0, 0%, 0%, 0.3)',

    '&.active': {
      visibility: 'visible',
    },
    '&.loading': {
      padding: '8px 16px',
      width: '200px',
    },
  },
  buttonWrapper: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '8px 16px',
    position: 'relative',
    opacity: '.7',
    '&:hover': {
      opacity: '1',
    },
  },
  icon: {
    display: 'flex',
    '& + *': {
      marginLeft: '8px',
    },
  },
  label: {},
  hiddenInput: {
    display: 'none !important',
  },
  hiddenInputClickArea: {
    opacity: '0',
    position: 'absolute',
    width: '100%',
    height: '100%',
    zIndex: 10,
    cursor: 'pointer',
  },
  linearProgress: {
    width: '100%',
  },
}
